export default __webpack_public_path__ + "static/media/1.1ad5850c.jpg";